import { useCallback, useMemo, useState } from 'react'
import { useVODStore } from '@/shared/store'

import {
    VodPageDetailsType,
    VodPageType,
    vodTypeEpisodes,
} from '@/shared/constants'
import { IItemDetails } from '@/shared/store/useVODStore'
import { shallow } from 'zustand/shallow'
import { SHOW_TYPE } from '@/clients/streamiq/shared/constantsStreamIq'

export const useSeriesContentLogic = () => {
    const {
        setSelectedVOD,
        setVodPages,
        vodPages,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isVodContentPlaying,
        searchItemDetails,
        removeItemDetail,
        setIsVodContentPlaying,
        itemDetails,
        setIsVodDetailsPageRendered,
    } = useVODStore(
        (state) => ({
            setSelectedVOD: state.setSelectedVOD,
            setVodPages: state.setVodPages,
            vodPages: state.vodPages,
            isVodContentPlaying: state.isVodContentPlaying,
            searchItemDetails: state.searchItemDetails,
            removeItemDetail: state.removeItemDetail,
            setIsVodContentPlaying: state.setIsVodContentPlaying,
            itemDetails: state.itemDetails,
            setIsVodDetailsPageRendered: state.setIsVodDetailsPageRendered,
        }),
        shallow
    )

    const [triggerScroll, setTriggerScroll] = useState({
        isScroll: false,
        counter: 0,
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const currentVodPageId = useMemo(
        () => vodPages[vodPages.length - 1]?.itemId,
        [vodPages.length]
    )
    const vodNavigationPath = useMemo(
        () => vodPages?.map((item) => item.title),
        [vodPages.length]
    )
    const currentPage = useMemo(
        () => vodPages[vodPages.length - 1],
        [vodPages.length]
    )
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const memoTriggerScroll = useMemo(() => triggerScroll, [triggerScroll])

    const memoSetTriggerScroll = useCallback(
        ({
            isScroll,
            amount,
            type,
        }: {
            isScroll: boolean
            amount: number
            type: 'increase' | 'decrease'
        }) => {
            setTriggerScroll((prev) => ({
                isScroll,
                counter:
                    type === 'increase'
                        ? prev.counter + amount
                        : prev.counter - amount,
            }))
        },
        [setTriggerScroll]
    )

    const isDetailsPageType = [
        SHOW_TYPE,
        VodPageDetailsType,
        vodTypeEpisodes,
    ].includes(currentPage.type)

    const shouldShowVodDetailsPage = useMemo(
        () => searchItemDetails || isDetailsPageType,
        [searchItemDetails, isDetailsPageType]
    )

    const handleNavBarElementClick = useCallback(
        (title: string, index: number) => {
            const destinationPage = vodPages.find(
                (item) => item.title === title
            )
            setIsVodContentPlaying(false)
            const itemDetailsIndex = itemDetails?.findIndex(
                (item: { item: IItemDetails; id: number }) =>
                    item.id === index + 1
            )
            if (
                destinationPage?.itemId === vodPages[vodPages.length - 1].itemId
            )
                return

            if (destinationPage) {
                setVodPages(undefined, undefined, VodPageType, index + 1)

                if (
                    destinationPage.type === VodPageDetailsType &&
                    itemDetailsIndex !== -1 &&
                    itemDetailsIndex !== undefined
                ) {
                    removeItemDetail(itemDetailsIndex + 1)
                    setSelectedVOD(null)
                }
            }
        },
        [
            vodPages,
            setIsVodContentPlaying,
            itemDetails,
            setVodPages,
            removeItemDetail,
            setSelectedVOD,
        ]
    )

    return {
        vodNavigationPath,
        handleNavBarElementClick,
        searchItemDetails,
        memoSetTriggerScroll,
        shouldShowVodDetailsPage,
        currentPage,
        setIsVodDetailsPageRendered,
    }
}
